<template>
  <nav aria-label="paginación de resultados">
    <ul class="pagination justify-content-md-end justify-content-center">
      <li class="page-item" v-bind:class="{disabled: prev < 1}">
        <a class="page-link d-none d-md-block" @click.prevent="onPageUpdate(prev)" tabindex="-1" :data-page="prev" aria-label="página anterior">Anterior</a>
        <!--<a class="page-link d-block d-md-none" @click.prevent="onPageUpdate(prev)" tabindex="-1" :data-page="prev" aria-label="página anterior">Ant.</a>-->
      </li>
      <li v-bind:class="{ disabled: current === page, active: current === page }" class="page-item" v-for="page in pagesRange" :key="page">
        <a class="page-link" @click.prevent="onPageUpdate(page)">{{ page }}</a>
      </li>

      <li class="page-item disabled" v-bind:class="{hide: pageItemMaxReached || pages <=5 }"><a class="page-link">…</a></li>

      <li class="page-item" v-bind:class="{disabled: next < 1}">
        <a class="page-link d-none d-md-block" @click.prevent="onPageUpdate(next)" aria-label="siguiente página">Siguiente</a>
        <!--<a class="page-link d-block d-md-none" @click.prevent="onPageUpdate(next)" aria-label="siguiente página">Sig.</a>-->
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'SearchPaginationComponent',

  props: ['prev', 'current', 'next', 'pages'],

  mounted () {
  },

  methods: {
    onPageUpdate (page) {
      this.$emit('pageupdate', page)
      // this.$store.commit('pageUpdate', parseInt(page))
      // this.$store.dispatch('updateFilters').then(null)
    }
  },

  data () {
    return {
      pageItemMaxReached: false
    }
  },

  computed: {
    pagesRange () {
      let end = this.pages
      let pagesRange = Array.from({length: (end)}, (v, k) => (k + 1) + '')

      if (pagesRange.length > 5) {
        let currentPos = pagesRange.indexOf(this.current)

        let minOffset = currentPos - 2
        let maxOffset = currentPos + 3

        if (minOffset < 0) {
          maxOffset = maxOffset + Math.abs(minOffset)
          minOffset = 0
        }

        if (maxOffset > pagesRange.length) {
          minOffset -= maxOffset - pagesRange.length
        }

        if (maxOffset >= pagesRange.length) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.pageItemMaxReached = true
        }

        pagesRange = pagesRange.slice(minOffset, maxOffset)
      }

      return pagesRange
    }
  }
}
</script>

<style lang="scss" scoped>

  $mgreen: '#00ff00';
  $mblack: '#000000';

  .page-link {
    color: $mblack;
    cursor: pointer;
  }
  .page-link:hover {
    z-index: 2;
    color: $mgreen;
    text-decoration: none;
    background-color: #e9ecef;
    border-color: #dee2e6;
  }
  .page-item.disabled.active {
    font-weight: 500;
  }
  .page-item.disabled.active a {
    color: $mgreen !important;
  }
  .hide {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/SearchPaginationComponent.vue